/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { Table } from "react-bootstrap"
import dayjs from "dayjs"
import util from "../../../../ts/util"
import HaisyaTableCard from "./HaisyaTableCard"
import HaisyaTableCell from "./HaisyaTableCell"
import {
  ZyomuinListContext,
  SearchConditionContext,
  SelectCellContext,
  CalenderSearchContext,
  MihaisyaSearchContext,
} from "../HaisyaContext"

import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import { e勤怠区分, T勤怠区分 } from "../../../../constant/enum/unko"
import {
  THaisyaListGetReq,
  T車輌乗務員,
  T配車,
} from "../../../../service/order/haisya/THaisya"
import HaisyaService from "../../../../service/order/haisya/HaisyaService"
import { setAlerts } from "../../../../globalStore/alertStore"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../.."
import { 当日全配車 } from "../haisyaRegisterUtil"
import { RootState } from "../../../../globalStore/rootreducer"
import dateUtil from "../../../../ts/util/dateUtil"

const DayTab: React.FC<{ between: number }> = (props) => {
  const [日付List, set日付List] = useState<string[]>([])

  const [mihaisyaUpdate, setMihaisyaUpdate] = useState(false)
  const 休日List = useSelector((state: RootState) => state.date.休日List)
  const [wjMenu, setWjMenu] = useState<wjcInput.Menu>()
  const [配車wjMenu, set配車WjMenu] = useState<wjcInput.Menu>()

  const dispatch: AppDispatch = useDispatch()

  const { 車輌乗務員List: 乗務員List, set車輌乗務員List: set乗務員List } =
    useContext(ZyomuinListContext)
  const searchCondition = useContext(SearchConditionContext)
  const { chip, selectKey, setSelectData, setSelectKey, setIsModalShow } =
    useContext(SelectCellContext)
  const calenderSearch = useContext(CalenderSearchContext)
  const mihaisyaSearch = useContext(MihaisyaSearchContext)

  // TODO: onMenuClickメソッド内にuseContextの更新内容が反映されないためrefに逃がして確認する
  const select乗務員 = useRef<T車輌乗務員>()
  const select積日 = useRef<string>()
  const select配車 = useRef<T配車>()
  const searchConditionRef = useRef<THaisyaListGetReq>()

  //#region [method]
  const onMenuClick = useCallback(
    async (menu: wjcInput.Menu) => {
      if (
        select乗務員 == null ||
        select乗務員.current == null ||
        select積日 == null ||
        select積日.current == null ||
        searchConditionRef == null ||
        searchConditionRef.current == null
      )
        return
      const 当日配車 = 当日全配車(select乗務員.current, select積日.current)
      if (当日配車.length > 0) {
        alert("既に配車がされているため休暇にできません。")
        return
      }
      const 種別: T勤怠区分 | 0 = menu.selectedValue

      try {
        const service = new HaisyaService()
        const res = await service.kinmubiPost({
          乗務員ID: select乗務員.current.乗務員ID,
          勤務日: select積日.current,
          勤怠区分: 種別 !== 0 ? 種別 : undefined,
        })
        // 登録成功した場合、一覧の乗務員リストを更新
        if (res.data) {
          const ListRes = await service.getList(searchConditionRef.current)
          set乗務員List([...ListRes.data])
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [select乗務員, select積日, searchConditionRef]
  )

  // 配車用
  const 配車menuInitialized = (menu: wjcInput.Menu) => {
    set配車WjMenu(menu)
  }

  const on配車MenuClick = useCallback(
    async (menu: wjcInput.Menu) => {
      if (select乗務員 == null || select乗務員.current == null) return
      if (select配車 == null || select配車.current == null) return
      if (searchConditionRef == null || searchConditionRef.current == null) {
        return
      }
      const 車輌Target = select乗務員.current
      const target = select配車.current

      const 受注No = `${target.受注伝票番号}-${target.受注枝番}`
      if (!window.confirm(`${受注No}の割当を解除します。よろしいですか`)) return
      try {
        const service = new HaisyaService()
        const res = await service.putMihaisya(target.受注配車ID, {
          更新日時: target.更新日時!,
          積日: target.積日!,
          車輌ID: 車輌Target.車輌ID,
        })
        // 登録成功した場合、更新
        if (res.data) {
          setMihaisyaUpdate(true)
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [searchConditionRef, select乗務員, select配車]
  )

  //#endregion

  useEffect(() => {
    if (searchCondition == null || searchCondition.積日 == null) return
    const new日付List: string[] = []
    // 検索条件の日付の前後一日を日付Listに格納する
    for (let index = 0; index < props.between; index++) {
      new日付List.push(
        dayjs(searchCondition.積日)
          .subtract(1 - index, "d")
          .toISOString()
      )
    }
    set日付List([...new日付List])
  }, [props.between, searchCondition])

  const menuInitialized = (menu: wjcInput.Menu) => {
    setWjMenu(menu)
  }

  useEffect(() => {
    if (mihaisyaUpdate) {
      calenderSearch(searchConditionRef.current)
      mihaisyaSearch(searchConditionRef.current)
      setMihaisyaUpdate(false)
    }
  }, [mihaisyaUpdate])

  return (
    <div className="w-100 h-55rem  overflow-scroll">
      {/* <Table
        bordered
        className={["tumibi-table", `date-${props.between}`].join(" ")}> */}
      <Table className={["tumibi-table", `date-${props.between}`].join(" ")}>
        <thead>
          <tr>
            <th>
              <div>車番</div>
            </th>
            <th>
              <div>担当乗務員名</div>
            </th>
            {日付List.map((date) => {
              // 休日マスタを参照し、休日は赤にする
              const is休日 = dateUtil.HolidayCheck(date, 休日List) !== 0
              return (
                <th
                  className={["text-center", is休日 ? "holiday" : ""].join(" ")}
                  key={date}>
                  <div>{util.date.format(date, "MM/DD(ddd)")}</div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {乗務員List.map((車輌乗務員, rowIndex) => (
            <tr
              key={`${車輌乗務員.車輌ID}_${車輌乗務員.トレーラ車輌ID}_${車輌乗務員.乗務員ID}_${rowIndex}`}>
              <th className="syaryo-data">
                <div className="syaban">{車輌乗務員.車番}</div>
                <div className="fs-6">{車輌乗務員.車種区分名称1}</div>
                <div>{車輌乗務員.トレーラ車番}</div>
                <div className="fs-6">{車輌乗務員.トレーラ車種区分名称1}</div>
              </th>
              <th className="zyomuin-data">
                <div>{車輌乗務員.乗務員名}</div>
              </th>
              {日付List.map((str日付, i) => {
                const 受注配車 = 当日全配車(車輌乗務員, str日付)

                const key = `${車輌乗務員.車輌ID}_${車輌乗務員.トレーラ車輌ID}_${車輌乗務員.乗務員ID}_${rowIndex}_${str日付}`

                let cellClass = selectKey === key ? "select-cell" : ""

                const 欠勤データ = 車輌乗務員.欠勤リスト?.find((欠勤) =>
                  dayjs(欠勤.勤務日).isSame(dayjs(str日付), "date")
                )

                if (欠勤データ != null) {
                  switch (欠勤データ.勤怠区分 as T勤怠区分) {
                    case e勤怠区分.有給休暇:
                    case e勤怠区分.欠勤:
                    case e勤怠区分.慶忌休暇:
                    case e勤怠区分.特別休暇:
                      cellClass += " holiday"
                      break
                    default:
                      cellClass = ""
                      break
                  }
                }

                return (
                  <HaisyaTableCell
                    className={cellClass}
                    onClick={(e) => {
                      setSelectKey(key)
                      setSelectData({
                        車輌乗務員,
                        積日: str日付,
                        受注配車: 受注配車,
                      })
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      select乗務員.current = 車輌乗務員
                      select積日.current = str日付
                      searchConditionRef.current = searchCondition
                      if (wjMenu == null) return
                      // wjMenu?.show(e.nativeEvent)
                    }}
                    onDoubleClick={(_e) => {
                      setSelectKey(key)
                      setSelectData({
                        車輌乗務員,
                        積日: str日付,
                        受注配車: 受注配車,
                      })
                      setIsModalShow(true)
                    }}
                    zyomuin={車輌乗務員}
                    date={str日付}
                    haisoNo={受注配車.length + 1}
                    key={key}>
                    {受注配車.length > 0 && (
                      <HaisyaTableCard
                        onContextMenuHandler={(e, 配車) => {
                          searchConditionRef.current = searchCondition
                          select乗務員.current = 車輌乗務員
                          select配車.current = 配車
                          select積日.current = str日付
                          if (配車wjMenu == null) return
                          配車wjMenu.show(e.nativeEvent)
                        }}
                        chip={chip}
                        date={str日付}
                        zyomuin={車輌乗務員}
                        haisya={受注配車}></HaisyaTableCard>
                    )}
                  </HaisyaTableCell>
                )
              })}
            </tr>
          ))}
        </tbody>
      </Table>

      <wjrInput.Menu
        initialized={menuInitialized}
        selectedValuePath="cmd"
        style={{ display: "none" }}
        isDroppedDownChanged={(dropDown: wjcInput.DropDown) => {
          if (dropDown.isDroppedDown) {
          } else {
            select乗務員.current = undefined
            select積日.current = undefined
          }
        }}
        itemClicked={(e: wjcInput.Menu) => {
          onMenuClick(e)
        }}
        header="Context Menu">
        <wjrInput.MenuItem cmd={e勤怠区分.有給休暇}>有給</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.特別休暇}>特休</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.欠勤}>欠勤</wjrInput.MenuItem>
        <wjrInput.MenuSeparator></wjrInput.MenuSeparator>
        <wjrInput.MenuItem cmd={undefined}>取消</wjrInput.MenuItem>
      </wjrInput.Menu>

      <wjrInput.Menu
        initialized={配車menuInitialized}
        style={{ display: "none" }}
        isDroppedDownChanged={(dropDown: wjcInput.DropDown) => {
          if (dropDown.isDroppedDown) {
          } else {
            select乗務員.current = undefined
            select配車.current = undefined
            select積日.current = undefined
          }
        }}
        itemClicked={(e: wjcInput.Menu) => {
          on配車MenuClick(e)
        }}
        header="Context Menu">
        <wjrInput.MenuItem>
          <div className="text-danger">配車解除</div>
        </wjrInput.MenuItem>
      </wjrInput.Menu>
    </div>
  )
}

export default DayTab
